<template>
  <div>
    <v-alert
      prominent
      :type="type"
    >
      <v-layout align-center wrap>
        <div>{{ $t(text) }}</div>
      </v-layout>
    </v-alert>
  </div>
</template>

<script>
  export default {
    props: {
      error: {
        type: Boolean,
        requerido: false,
        default: false
      },
      text: {
        type: String,
        requerido: false,
        default: null
      }
    },
    computed: {
      type () {
        if (this.error) return 'error'
        return null
      }
    },
  }
</script>